import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS as _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "./ISO_TO_COUNTRY_NAME";
export var UPPERCASE_COUNTRY_NAME_TO_ISO = function(strictLocalize) {
    var ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS = _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize);
    var uppercaseCountriesToIso = {};
    Object.keys(ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS).forEach(function(iso) {
        return(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        uppercaseCountriesToIso[// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[iso].toUpperCase()] = iso);
    });
    return uppercaseCountriesToIso;
};
